import type { ReatomEvmContainer } from "@rarible_int/anaconda_sdk/ethereum"
import { action, atom } from "@reatom/core"
import { molecule } from "bunshi"

/**
 * Molecule for managing the EVM SDK container
 * Provides a single source of truth for the SDK with logging and actions
 */
export const EvmSdkContainerMoleculeReatom = molecule(() => {
  // Single atom to hold the SDK container
  const sdkContainerAtom = atom<ReatomEvmContainer | null>(
    null,
    "sdkContainerAtom",
  )

  // Action to update the SDK
  const updateSdk = action((sdk: ReatomEvmContainer | null, source: string) => {
    sdkContainerAtom.set(sdk)
  }, "updateSdk")

  // Action to clear SDK on logout
  const clearSdk = action(() => {
    sdkContainerAtom.set(null)
  }, "clearSdk")

  return {
    sdkContainerAtom,
    updateSdk,
    clearSdk,
  }
})
